import React, { FunctionComponent } from 'react'
import Box from '@material-ui/core/Box'
import { ReservationOffersProvider } from 'components/views/reservation-offers/ReservationOffersProvider'
import Message, { MessageProvider } from 'Elements/Message'
import Toolbar from 'components/views/reservation-offers/partials/Toolbar'
import List from 'components/views/reservation-offers/partials/List'

export type Props = {}
export type Functions = {}
export type AllProps = Props & Functions

const ReservationOffers: FunctionComponent<AllProps> = ({}) => {
  return (
    <Box p={1.5}>
      <ReservationOffersProvider>
        <MessageProvider>
          <Toolbar />
          <List />
          <Message />
        </MessageProvider>
      </ReservationOffersProvider>
    </Box>
  )
}

export default ReservationOffers
